module.exports = __webpack_public_path__ + "media/images/application2/AppBookingsTalk__panel__dl__item__dd-21997c804dbe63148fc99b9832efd396.svg";